import SolutionTemplate from "./SolutionTemplate";

const LeaveSolution = () => (
  <SolutionTemplate
    eyebrow="Leave management"
    title="Apply, approve and balance —"
    titleGradient="in one flow"
    subtitle="Employees apply for leave from their phone, supervisors approve with a tap, and balances update in real time. Supports accruals, LOP, sandwich policies and custom leave types."
    heroImg="/assets/img/leave_management.webp"
    heroImgAlt="TimeTango leave management"
    flowSteps={[
      { title: "Apply leave", desc: "Employee selects dates, type and reason from the app" },
      { title: "Manager approves", desc: "Supervisor gets notified and approves or rejects with a tap" },
      { title: "Balance updates", desc: "Leave balance and payroll are updated automatically" },
    ]}
    capabilities={[
      { icon: "📋", title: "Custom leave types", desc: "Earned, casual, sick, comp-off — configure any type" },
      { icon: "⚖️", title: "Accrual policies", desc: "Monthly, quarterly or annual accrual with carry-forward" },
      { icon: "📅", title: "Sandwich policy", desc: "Auto-include holidays/weekends between leave days" },
      { icon: "💰", title: "LOP adjustment", desc: "Loss of Pay tracked and reconciled automatically" },
      { icon: "👥", title: "Supervisor workflow", desc: "Multi-level approval with email notifications" },
      { icon: "📈", title: "Leave reports", desc: "Balance reports, trend analysis and Excel export" },
    ]}
    benefits={[
      { title: "Zero manual tracking", desc: "No more spreadsheets — balances compute automatically." },
      { title: "Policy compliance", desc: "Enforce carry-forward limits, probation rules and more." },
      { title: "Employee self-service", desc: "Employees see their balances and history anytime." },
      { title: "Payroll-ready", desc: "Leave data integrates directly with payroll processing." },
    ]}
    relatedSlugs={["/solutions/attendance", "/solutions/timesheet", "/solutions/activity-tracking"]}
    metaTitle="Leave Management System | TimeTango"
    metaDescription="Automated leave management with custom types, accrual policies, sandwich rules and real-time balances. Apply, approve and track from any device."
  />
);

export default LeaveSolution;
